<template>
    <div class="main">
        <h3 v-if="!businessDataChange" style="margin-top:-10vh;margin-bottom:20px">
            <img src="@/assets/img/logo_notext.png" style="width:40px" alt="">
            科小查询
        </h3>
        <div class="search-box" ref="serchbox">
            <input type="text" v-model="EnterpriseName" placeholder="请输入企业名称" @blur="getEnterpriseName"
                   class="search-input">
            <button @click="goDetail" class="search-button">查 询</button>
        </div>
        <!--<a-table style="width:100%;max-height:84vh;overflow-y:auto" v-if="businessDataChange" :columns="columns" :data-source="businessData"></a-table>-->
        <a-list v-if="businessDataChange" :data-source="businessData">
            <template #renderItem="{ item }">
                <a-list-item @click="showDetailModal(item)">{{ item.companyName }}</a-list-item>
            </template>
            <template #loadMore>
                <div :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
                    <a-spin v-if="loadingMore"/>
                    <a-button v-if="!loadingMore && hasMore" @click="loadMore">加载更多</a-button>
                </div>
            </template>
        </a-list>
    </div>
    <!--    <high-enterprise-detail ref="detail"/>-->
</template>

<script>
import {dictMixin, getDistMixin, listMixin} from "@/mixins";
import {file_service, login_mp, sys_admin, sys_policyNotice} from "@/api/adminService";
import {ls} from "@/utils/util"
import {enterpriseOperatingIncome} from "@/api/integral";
import {basicsSS} from "@/api/highEnterpriserch";
import {getBannerInfo, getWebInfo, noticeInfo} from "@/api/homeService";
import {platformName} from "@/config/platformConfig";

const columns = [
    {title: "企业名称", dataIndex: "companyName", align: 'center', key: "companyName"},
    // {title: "生效年份", dataIndex: "takeTime", key: "takeTime"},
    // {title: "企业统一社会信用代码", dataIndex: "companyCode", key: "companyCode"},
];
export default {
    name: "index",
    components: {},
    mixins: [dictMixin, getDistMixin, listMixin],
    data() {
        return {
            EnterpriseName: null,
            sizes: 16,
            businessDataChange: null,
            columns,
            dictNames: 'policy_type',
            noticeData: [],
            fourObj: {},
            user: {},
            getDetailNoteParam: null,
            operatingIncomeScale: null,
            platformName,
            getAuditStatus: null,
            visible: false,
            getDateId: null,
            formState: {
                user: undefined,
            },
            noticeObj: {},
            bannerData: [],
            webSiteInfo: {},
            linkData: [],
            source: '',
            queryParam: {},
            listUrl: noticeInfo.pageList,
            current: 1,
            pageSize: 10,
            pages: 0,
            total: 0,
            str: null,
            businessData: [],
            loadingMore: false,
            hasMore: false
        }
    },
    methods: {
        loadMore() {
            this.current++
            this.loadingMore = true
            this.getAction({
                url: basicsSS.pageList,
                params: {companyName: this.EnterpriseName, pageNum: this.current, pageSize: this.pageSize}
            }).then(resp => {
                this.loadingMore = false
                this.businessData.push(...resp.records)
                this.hasMore = this.current < resp.pages && resp.total > 0
            })
        },
        showDetailModal(item) {
            this.$router.push({
                path: '/highEnterpriseDetail',
                query: {
                    companyName: item.companyName,
                    warehousingCode: item.warehousingCode,
                    companyCode: item.companyCode,
                    takeTime: item.takeTime
                }
            })
        },
        logout() {
            let self = this;

            self.$ls.clear();
            self.$store.commit('setMenuData', []);
            self.$router.replace('/');

            location.reload();
        },
        onLogout() {
            let self = this;
            self.$confirm({
                title: '确认要退出登录?',
                content: '',
                onOk() {
                    self.postAction({
                        url: login_mp.saveLog,
                        params: {logAppCategoryEnum: "LOGOUT"}
                    }).then(res => {
                        console.log(res)
                        self.getAction({
                            url: login_mp.logout,
                            params: {access_token: ls.get("token") || ""},
                            isValid: false
                        }).then(() => {
                            self.$notification['success']({
                                message: '退出成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
                        })
                    })


                    setTimeout(() => {
                        self.logout();
                    }, 2000)
                },
                onCancel() {
                },
            });
        },
        goMorePolicy() {
            this.$router.push({
                path: '/notice',
                // query: { type: "资讯公告", activeKey: 2 }
            })
        },
        getEnterpriseName() {
            if (this.EnterpriseName) {
                this.goDetail()
            } else {
                this.businessDataChange = false
                this.businessData = null
                this.$refs.serchbox.style.marginTop = '0'
            }
        },
        goDetail() {
            this.current = 1    //重新搜索 重置起始页
            this.businessDataChange = true
            if (this.EnterpriseName) {
                this.getAction({
                    url: basicsSS.pageList,
                    params: {companyName: this.EnterpriseName, pageNum: this.current, pageSize: this.pageSize}
                }).then(res => {
                    this.$refs.serchbox.style.marginTop = '-5vh'
                    this.businessData = res.records
                    this.current = parseInt(res.current)
                    this.pageSize = parseInt(res.size)
                    this.pages = res.pages
                    this.total = res.total
                    this.hasMore = this.pages > this.current
                })
            }
        },
        getUserInfo() {
            this.getAction({
                url: sys_admin.userInfor
            }).then(res => {
                sessionStorage.setItem("roleCode", res.roleCode.split(','));
            })
        },
        goHttp(url) {
            window.open(url, '_bank')
        },
        goMore(url, str) {
            this.$router.push({path: url, query: {id: str}})
        },
        goMoreNotice(url, str) {
            console.log('url: ', url, str)
            this.$router.push({path: url, query: {...str}})
        },
        getDetail() {
            if (this.$route.query.type == 1) {
                this.getAction({
                    url: sys_policyNotice.detail,
                    params: {id: this.$route.query.id}
                }).then(res => {
                    this.noticeObj = res
                })
            } else {
                this.getAction({
                    url: noticeInfo.noticeDetail,
                    params: {id: this.$route.query.id}
                }).then(res => {
                    this.noticeObj = res
                })
            }
        },
        getPolicyNotice() {
            this.getAction({
                url: sys_policyNotice.detail,
                params: {id: this.$route.query.id}
            }).then(res => {
                this.noticeObj = res
            })
        },
        goNoticeList() {
            if (this.$route.query.source == 'piao') {
                this.$router.push({
                    path: '/notice',
                    query: {source: 'piao'}
                })
            } else {
                this.$router.push({
                    path: '/notice',
                    query: {type: this.str}
                })
            }
        },
        getDate() {
            this.getAction({
                url: enterpriseOperatingIncome.getDate,
                // params: { id: id },
                returnMsg: true,
            }).then((res) => {
                this.getDateId = res.data
                // auditStatus
            });
        },
        islogin() {
            if (ls.get('token') && ls.get("refresh_token")) {
                if (ls.get("roleCode").includes('company')) {
                    this.goMore('/sys/companyInfo')
                } else if (ls.get("roleCode").includes('technicalManager')) {
                    this.goMore('/sys/technology/person');
                } else if (ls.get("roleCode").includes('serviceOrganization')) {
                    this.goMore('/sys/innovation/organization/index');
                } else if (ls.get("roleCode").includes('investorManager')) {
                    this.goMore('/finance/investorInformation');
                } else if (ls.get("roleCode").includes('investmentMechanism')) {
                    this.goMore('/finance/investmentOrganizationInformation');
                } else if (ls.get("roleCode").includes('financialAdviser')) {
                    this.goMore('/finance/financialAdvisorInformation');
                } else {
                    this.goMore('/sys/userInfo')
                }
            } else {
                this.goMore('/login', 'user')
            }
        },
        getBannerList() {
            this.getAction({
                url: getBannerInfo.pageList,
                params: {type: 'home'}
            }).then(res => {
                this.bannerData = res.records.reverse()
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getWebInfo() {
            this.getAction({
                url: getWebInfo.detail,
                params: {id: 1}
            }).then(res => {
                this.webSiteInfo = res
            })
        },
    },
    mounted() {

    }
}
</script>

<style scoped lang="less">
.main {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .search-box {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        width: 85vw;
        background-color: #f2f2f2;
        border-radius: 20px;
        padding: 5px;
    }

    .search-input {
        flex: 1;
        border: none;
        padding-left: 10px;
        border-radius: 20px;
        background-color: transparent;
        outline: none;
        font-size: 16px;
    }

    .search-button {
        border: none;
        width: 22vw;
        background-color: #ff6600; /* 修改为橙色 */
        color: #fff;
        padding: 10px 0;
        border-radius: 20px;
        margin-left: 5px;
        cursor: pointer;
        outline: none;
        font-size: 16px;
    }

    .search-button:hover {
        background-color: #ff8533; /* 修改为橙色的hover效果 */
    }
}

:deep(.ant-btn) {
    color: #fc550b;
    font-weight: 600;
    padding: 0 10px;

    img {
        margin-right: 5px
    }

    &:hover {
        border-color: #ffffff;
        box-shadow: 1px 1px 5px 1px #a7a7a7;
    }
}

:deep(.ant-list-lg .ant-list-item) {
    padding: 16px 8px;
}

:deep(.ant-list) {
    height: 80%;
    width: 100%;
    overflow-y: scroll;
}

:deep(.ant-list-item) {
    justify-content: center;
}
</style>
